import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import ProductCard from './ProductCard';
import ProductSelectionForm from './ProductSelectionForm';
import { useComparison } from '../../context/ComparisonContext';


export default function Topproducts() {
    const { comparisions } = useComparison();

    React.useEffect(() => {
        if (comparisions.length) {
            let names = "";
            comparisions.forEach(item => {
                if (names !== "") {
                    names += " Vs " + item.variant;
                } else {
                    names += item.variant
                }
            });
            document.getElementById("compare-heading-main").innerHTML = `Compare ${names}`;
        }
    }, [comparisions])

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>

                <Grid size={{ xs: 12, md: 3 }}>
                </Grid>

                {comparisions ? (comparisions.map(item => (
                    <Grid size={{ xs: 12, sm: 3 }} key={item.variant}>
                        <ProductCard variant={item} />
                    </Grid>
                ))) : (<p>No posts available</p>)}

                {comparisions.length < 3 ? (<Grid size={{ xs: 12, md: 3 }}>
                    <ProductSelectionForm />
                </Grid>) : null}

            </Grid>
        </Box>
    );
}
